// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


function localeFromLanguage(x) {
  if (x === "en") {
    return /* En */4;
  } else if (x === "es") {
    return /* Es */5;
  } else if (x === "fr") {
    return /* Fr */0;
  } else if (x === "it") {
    return /* It */3;
  } else if (x === "pl") {
    return /* Pl */2;
  } else {
    return /* De */1;
  }
}

function localeToString(x) {
  switch (x) {
    case /* Fr */0 :
        return "fr";
    case /* De */1 :
        return "de";
    case /* Pl */2 :
        return "pl";
    case /* It */3 :
        return "it";
    case /* En */4 :
        return "en";
    case /* Es */5 :
        return "es";
    
  }
}

function stringToLanguage(x) {
  switch (x) {
    case "de" :
        return "de";
    case "en" :
        return "en";
    case "es" :
        return "es";
    case "it" :
        return "it";
    case "pl" :
        return "pl";
    default:
      return "fr";
  }
}

function localeToLanguage(locale) {
  switch (locale) {
    case /* Fr */0 :
        return "fr";
    case /* De */1 :
        return "de";
    case /* Pl */2 :
        return "pl";
    case /* It */3 :
        return "it";
    case /* En */4 :
        return "en";
    case /* Es */5 :
        return "es";
    
  }
}

function isEurope(locale) {
  return locale >= 2;
}

exports.localeFromLanguage = localeFromLanguage;
exports.localeToString = localeToString;
exports.stringToLanguage = stringToLanguage;
exports.localeToLanguage = localeToLanguage;
exports.isEurope = isEurope;
/* No side effect */
